/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject, Subject } from 'rxjs';

export interface Filters {
  price?: PriceFilter;
  inventory?: FilterItem;
  shower?: FilterItem;
  wardrobe?: FilterItem;
  lighting?: FilterItem;
  parking?: FilterItem;
  tribunes?: FilterItem;
  toilet?: FilterItem;
}

export interface FilterItem {
  name: string;
  value: boolean;
}

export interface PriceFilter {
  name: string;
  value: PriceRange;
}

export interface PriceRange {
  lower: number;
  upper: number;
}

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  private _filters: BehaviorSubject<Filters> = new BehaviorSubject({
    price: { name: 'Цена', value: { lower: 0, upper: 2000 } },
    inventory: { name: 'Инвентарь', value: false },
    shower: { name: 'Душ', value: false },
    wardrobe: { name: 'Гардероб', value: false },
    lighting: { name: 'Освещение', value: false },
    parking: { name: 'Паркинг', value: false },
    tribunes: { name: 'Трибуны', value: false },
    toilet: { name: 'Туалет', value: false }
  });

  constructor() { }

  getFilter(): Observable<Filters> {
    return this._filters.asObservable();
  }

  setFilter(filter: FilterItem | PriceFilter) {
    const currentFilters = this._filters.getValue();

    const updatedFilters = Object.assign({}, currentFilters);
    const filterToChange = Object.entries(updatedFilters).find((entry: [string, any]) => entry[1].name === filter.name);
    updatedFilters[filterToChange[0]] = filter;

    this._filters.next(updatedFilters);
    console.log('updatedFilters: ', updatedFilters);
  }

  resetFilters() {
    this._filters.next({
      price: { name: 'Цена', value: { lower: 0, upper: 2000 } },
      inventory: { name: 'Инвентарь', value: false },
      shower: { name: 'Душ', value: false },
      wardrobe: { name: 'Гардероб', value: false },
      lighting: { name: 'Освещение', value: false },
      parking: { name: 'Паркинг', value: false },
      tribunes: { name: 'Трибуны', value: false },
      toilet: { name: 'Туалет', value: false }
    });
  }
}
